import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

import {
  nextCoursesMock,
  recentCoursesMock,
  streaksMock,
  activeRoutesMock,
  finishedCoursesMock,
  searchCardCoursesMock,
  searchCardRoutesMock,
  searchTableContentMock,
} from '../myLearning.mock';

const delay = 3000;

const getRecentCourses = rest.get(
  `${API_REST_URL}/my-learning/recent-courses/:clientId/:userId`,
  (req, res, ctx) => {
    return res(ctx.delay(delay), ctx.json(recentCoursesMock), ctx.json([]));
  },
);

const getNextCourses = rest.get(
  `${API_REST_URL}/my-learning/next-courses/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.delay(delay),
      ctx.json(nextCoursesMock),
      // ctx.json([])
    );
  },
);

const getYearStreak = rest.get(
  `${API_REST_URL}/my-learning/year-streak/:clientId/:userId/:year`,
  (req, res, ctx) => {
    const { year } = req.params;
    const response = { ...streaksMock, year: Number(year) };
    return res(ctx.delay(delay), ctx.json(response));
  },
);

const getActiveRoutes = rest.get(
  `${API_REST_URL}/my-learning/my-active-routes/:clientId/:userId`,
  (req, res, ctx) => {
    return res(ctx.delay(delay), ctx.json(activeRoutesMock));
  },
);

const getApprovedCourses = rest.get(
  `${API_REST_URL}/my-learning/my-approved-courses/:clientId/:userId`,
  (req, res, ctx) => {
    return res(/* ctx.delay(delay), */ ctx.json(finishedCoursesMock));
  },
);

const getCardCourses = rest.post(
  `${API_REST_URL}/my-learning-search-engine/courses/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: searchCardCoursesMock,
      }),
    );
  },
);

const getCardRoutes = rest.post(
  `${API_REST_URL}/my-learning-search-engine/routes/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: searchCardRoutesMock,
      }),
    );
  },
);

const getTableContent = rest.post(
  `${API_REST_URL}/my-learning-search-engine/all-resources/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: searchTableContentMock,
      }),
    );
  },
);

const unsubscribeFromResource = rest.post(
  `${API_REST_URL}/my-learning-unsubscribe`,
  (req, res, ctx) => {
    return res(ctx.delay(1000), ctx.status(200), ctx.json({}));
  },
);

export const myLearningHandlers = [
  // getRecentCourses,
  // getNextCourses,
  // getYearStreak,
  // getActiveRoutes,
  // getApprovedCourses,
  // getCardCourses,
  // getCardRoutes,
  // getTableContent,
  unsubscribeFromResource,
];
